namespace GeniuzPOS.CustomReport {

    @Serenity.Decorators.registerClass()
    export class ReportCustomerSurveyTranDtEditor extends Serenity.Extensions.GridEditorBase<ReportCustomerSurveyTranDtRow> {
        protected getColumnsKey() { return "ReportMasterData.ReportCustomerSurveyTranDt"; }
        protected getDialogType() { return ReportCustomerSurveyTranDtDialog; }
        protected getLocalTextPrefix() { return ReportCustomerSurveyTranDtRow.localTextPrefix; }
        protected getService() { return ReportCustomerSurveyTranDtService.baseUrl; }
        
        public qnNo: number;

        public myPassValue: string;        
        

        constructor(container: JQuery) {
            super(container);
        
        }      

        protected getButtons(): Serenity.ToolButton[] {
            var buttons = super.getButtons();
           
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);
            buttons.push(Common.Helpers.ExcelExportHelper.createToolButton({
                grid: this,
                service: ReportCustomerSurveyTranDtService.baseUrl + '/ListExcel',
                onViewSubmit: () => this.onViewSubmit(),
                separator: true
            }));



            return buttons;
        }
    
        protected getSlickOptions() {
            var opt = super.getSlickOptions();
            opt.showFooterRow = true;
            return opt;
        }

        protected getViewOptions() {
            var opt = super.getViewOptions();
            opt.localSort = true;
            return opt;
        }

        protected usePager() {
            return false;
        }

    }
}

